import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
  microsoftAuthApiRef,
} from '@backstage/core-plugin-api';
import {
  ScaffolderClient,
  scaffolderApiRef,
} from '@zephyr-abl-tech/plugin-scaffolder';
// import { costInsightsApiRef } from '@zephyr-abl-tech/plugin-cost-insights';

import { techRadarApiRef } from '@backstage/plugin-tech-radar';
import { TechRadar } from './lib/techRadar/techRadar';
// import { CostInsights } from './lib/costInsights/CostInsights';
import { searchApiRef } from '@backstage/plugin-search-react';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  // EventSource can't send an Authorization header; polling goes through fetchApi.
  createApiFactory({
    api: scaffolderApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      scmIntegrationsApi: scmIntegrationsApiRef,
      fetchApi: fetchApiRef,
      identityApi: identityApiRef,
    },
    factory: ({ discoveryApi, scmIntegrationsApi, fetchApi, identityApi }) =>
      new ScaffolderClient({
        discoveryApi,
        scmIntegrationsApi,
        fetchApi,
        identityApi,
        useLongPollingLogs: true,
      }),
  }),
  createApiFactory({
    api: techRadarApiRef,
    deps: { microsoftAuthApi: microsoftAuthApiRef },
    factory({ microsoftAuthApi }) {
      return new TechRadar({ token: microsoftAuthApi });
    },
  }),
  // createApiFactory({
  //   api: costInsightsApiRef,
  //   deps: { configApi: configApiRef },
  //   factory({ configApi }) {
  //     return new CostInsights({ apiUrl: configApi.getString('app.apiUrl') });
  //   },
  // }),
];
